import React from 'react'
import cx from 'classnames'
import style from './index.scss'

import { ReactComponent as Tick } from './tick.inline.svg'
import { ReactComponent as Alert } from './alert.inline.svg'

interface Props {
  type?: 'success' | 'info' | 'failure'
  message?: React.ReactNode
  onClickDismiss?: () => void
  className?: string
}

const Notification: React.FC<Props> = ({
  type,
  message,
  onClickDismiss,
  className,
}) => {
  return (
    <div className={cx(style.Notification, type && style[type], className)}>
      <header className={style.header}>
        {type === 'success' ? (
          <Tick className={cx(style.icon, type && style[type])} />
        ) : (
          <Alert className={cx(style.icon, type && style[type])} />
        )}
        <span className={style.message}>{message}</span>

        {onClickDismiss && (
          <button
            aria-label="Dismiss"
            onClick={onClickDismiss}
            className={style.dismiss}
          >
            <svg
              className={type ? style[type] : undefined}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path fill="none" d="M13 13L1 1m12 0L1 13" />
            </svg>
          </button>
        )}
      </header>
    </div>
  )
}

export default Notification
